import * as v from 'valibot';

import { cargoTypeSchema, carrierSchema, customerSchema } from '@/modules/entities';
// Subset of PricingHeader: only the fields rendered by the pricing card
export const pricingHeaderApiSchema = v.object({
  cargoType: v.nullable(v.string()),
  carrierKey: v.number(),
  customerKey: v.number(),
  pricingKey: v.number(),
});

export const pricingHeaderSchema = v.object({
  cargoType: v.nullable(cargoTypeSchema),
  carrier: carrierSchema,
  customer: customerSchema,
  id: v.string(),
  pricingKey: v.string(),
});

export const tariffPricingApiSchema = v.array(pricingHeaderApiSchema);

export const tariffPricingSchema = v.array(pricingHeaderSchema);

export type PricingHeaderApi = v.InferOutput<typeof pricingHeaderApiSchema>;
export type TariffPricingApi = v.InferOutput<typeof tariffPricingApiSchema>;

export type PricingHeader = v.InferOutput<typeof pricingHeaderSchema>;
export type TariffPricing = v.InferOutput<typeof tariffPricingSchema>;
